import { withErrorGuard } from 'api/utils';
import { AlwSupportedGamesIds } from '../types';
import { MAIN_URL } from './config';
import { AlwLadderResponse } from './types';

export const AlwApi = {
    getAlwLadder: (game: AlwSupportedGamesIds, offset?: number, limit = 100) => {
        return withErrorGuard<AlwLadderResponse>(
            `${MAIN_URL}/alw/ladder?gameId=${game}&limit=${limit}${
                offset ? `&offset=${offset}` : ''
            }`,
            {
                method: 'GET',
                headers: {
                    Authorization: localStorage.getItem('buff-token') || '',
                },
            },
        );
    },
};
